module.exports = __webpack_public_path__ + "icon-archive.svg";